<mat-form-field>
  <mat-label>{{ label }}</mat-label>
  <input
    type="text"
    matInput
    [placeholder]="placeholder"
    [attr.aria-label]="label"
    [formControl]="control"
    [matAutocomplete]="auto" />
  @if (showClear(loading$ | async)) {
    <button
      type="button"
      mat-icon-button
      matSuffix
      color="warn"
      matTooltip="Clear selection"
      (click)="clear($event)">
      <mat-icon>close</mat-icon>
    </button>
  }
  @if (!control.disabled && (loading$ | async)) {
    <mat-spinner mode="indeterminate" matSuffix diameter="16"></mat-spinner>
  }
  <mat-autocomplete #auto="matAutocomplete" [displayWith]="display">
    @for (option of options$ | async; track option.id) {
      <mat-option [value]="option">{{ display(option) }}</mat-option>
    }
  </mat-autocomplete>
</mat-form-field>
